<!--This file is part of sisdai-proyecto-base.-->

<!--sisdai-proyecto-base is free software: you can redistribute it and/or modify-->
<!--it under the terms of the GNU Lesser General Public License as published by the-->
<!--Free Software Foundation, either version 3 of the License, or-->
<!--(at your option) any later version.-->

<!--sisdai-proyecto-base is distributed in the hope that it will be useful,-->
<!--but WITHOUT ANY WARRANTY; without even the implied warranty of-->
<!--MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General-->
<!--Public License for more details.-->

<!--You should have received a copy of the GNU Lesser General Public License along-->
<!--with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.-->

<script setup>
const domain = process.env.VUE_APP_ENI_DOMAIN
</script>

<template>
  <SisdaiNavegacionPrincipal
    :nav-informacion="`Sección: <b>${$route.name}</b>`"
  >
    <template #complementario>
      <a
        :href="domain"
        class="nav-hipervinculo"
        target="_blank"
      >
        <b>IR A ENI CULTURA</b>
      </a>
    </template>
    <ul class="nav-menu">
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/"
          exact
        >
          Inicio
        </router-link>
      </li>
      <!-- <li>
        <router-link
          class="nav-hipervinculo"
          to="/catalogo"
        >
          Catálogo
        </router-link>
      </li>
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/pueblos"
        >
          Pueblos
        </router-link>
      </li>
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/politica"
        >
          Política
        </router-link>
      </li> -->
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/metodologia"
        >
          Metodología
        </router-link>
      </li>
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/glosario"
        >
          Glosario
        </router-link>
      </li>
      <li>
        <router-link
          class="nav-hipervinculo"
          to="/creditos"
        >
          Créditos
        </router-link>
      </li>
    </ul>
  </SisdaiNavegacionPrincipal>
</template>
